<template>
  <MainLayout>
    <v-container class="mt-10" fluid>
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>

      <v-row>
        <!-- Toplam Telefon Stoku -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="dashboard-card" color="primary">
            <v-card-text>
              <div class="d-flex justify-space-between">
                <div>
                  <p class="text-h4 font-weight-bold white--text mb-1">
                    {{ totalPhones }}
                  </p>
                  <p class="text-subtitle-1 white--text mb-0">
                    Toplam Telefon Stoku
                  </p>
                </div>
                <v-icon size="48" color="white" class="ml-3"
                  >mdi-cellphone</v-icon
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Toplam Aksesuar Stoku -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="dashboard-card" color="success">
            <v-card-text>
              <div class="d-flex justify-space-between">
                <div>
                  <p class="text-h4 font-weight-bold white--text mb-1">
                    {{ totalAccessories }}
                  </p>
                  <p class="text-subtitle-1 white--text mb-0">
                    Toplam Aksesuar Stoku
                  </p>
                </div>
                <v-icon size="48" color="white" class="ml-3"
                  >mdi-headphones</v-icon
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Günlük Ciro -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="dashboard-card" color="info">
            <v-card-text>
              <div class="d-flex justify-space-between">
                <div>
                  <p class="text-h4 font-weight-bold white--text mb-1">
                    {{ formatCurrency(dailyRevenue) }}
                  </p>
                  <p class="text-subtitle-1 white--text mb-0">Günlük Ciro</p>
                </div>
                <v-icon size="48" color="white" class="ml-3"
                  >mdi-cash-register</v-icon
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Aylık Ciro -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="dashboard-card" color="deep-purple">
            <v-card-text>
              <div class="d-flex justify-space-between">
                <div>
                  <p class="text-h4 font-weight-bold white--text mb-1">
                    {{ formatCurrency(monthlyRevenue) }}
                  </p>
                  <p class="text-subtitle-1 white--text mb-0">Aylık Ciro</p>
                </div>
                <v-icon size="48" color="white" class="ml-3"
                  >mdi-chart-line</v-icon
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Döviz Kurları ve Yeni Ürün Talebi -->
      <v-row class="mt-4">
        <!-- Döviz Kurları -->
        <v-col cols="12" md="8">
          <v-card class="dashboard-card">
            <v-card-title class="d-flex align-center">
              <span class="text-h6">Günlük Döviz Kurları</span>
              <v-spacer></v-spacer>
              <v-chip color="success" small class="ml-2">
                Son Güncelleme: {{ lastUpdate }}
              </v-chip>
            </v-card-title>
            <v-card-text>
              <v-row>
                <!-- USD -->
                <!-- USD Kartı -->
                <v-col cols="12" sm="4">
                  <v-card outlined class="currency-card">
                    <v-card-text class="text-center">
                      <div class="text-h6">USD/TRY</div>
                      <div class="text-h4">{{ displayRates.usd }}</div>
                      <v-chip
                        small
                        :color="getRateColor(displayRates.usdChange)"
                      >
                        {{ displayRates.usdChange > 0 ? "+" : ""
                        }}{{ displayRates.usdChange }}%
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- EUR Kartı -->
                <v-col cols="12" sm="4">
                  <v-card outlined class="currency-card">
                    <v-card-text class="text-center">
                      <div class="text-h6">EUR/TRY</div>
                      <div class="text-h4">{{ displayRates.eur }}</div>
                      <v-chip
                        small
                        :color="getRateColor(displayRates.eurChange)"
                      >
                        {{ displayRates.eurChange > 0 ? "+" : ""
                        }}{{ displayRates.eurChange }}%
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- GBP Kartı -->
                <v-col cols="12" sm="4">
                  <v-card outlined class="currency-card">
                    <v-card-text class="text-center">
                      <div class="text-h6">GBP/TRY</div>
                      <div class="text-h4">{{ displayRates.gbp }}</div>
                      <v-chip
                        small
                        :color="getRateColor(displayRates.gbpChange)"
                      >
                        {{ displayRates.gbpChange > 0 ? "+" : ""
                        }}{{ displayRates.gbpChange }}%
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Yeni Ürün Talebi -->
        <v-col cols="12" md="4">
          <v-card
            height="100%"
            class="dashboard-card d-flex align-center justify-center"
          >
            <v-btn
              x-large
              color="primary"
              @click="showNewProductDialog"
              class="px-8"
            >
              <v-icon left>mdi-plus</v-icon>
              Yeni Ürün Talebi
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Devamı bir sonraki mesajda -->
      <!-- Grafikler -->
      <v-row class="mt-4">
        <!-- Personel Satış Performansı -->
        <v-col cols="12" md="6">
          <v-card class="dashboard-card">
            <v-card-title class="text-h6">
              Personel Satış Performansı (Günlük)
            </v-card-title>
            <v-card-text style="height: 400px">
              <div class="chart-container">
                <canvas id="salesChart"></canvas>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Aylık Ciro Grafiği -->
        <v-col cols="12" md="6">
          <v-card class="dashboard-card">
            <v-card-title class="text-h6">
              Aylık Ciro Grafiği ({{ currentYear }})
            </v-card-title>
            <v-card-text style="height: 400px">
              <div class="chart-container">
                <canvas id="revenueChart"></canvas>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Azalan Ürünler Tablosu -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card class="dashboard-card">
            <v-card-title class="d-flex align-center">
              <span class="text-h6">Azalan Ürünler</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Ara"
                single-line
                hide-details
                class="ml-4"
                style="max-width: 300px"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="lowStockItems"
              :search="search"
              :items-per-page="5"
              class="elevation-0"
            >
              <template #[`item.stock`]="{ item }">
                <v-chip :color="getStockColor(item.stock)" dark small>
                  {{ item.stock }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  color="primary"
                  small
                  @click="createRestockRequest(item)"
                >
                  Stok Talebi
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- Yeni Ürün Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Yeni Ürün Talebi</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newProduct.name"
                    label="Ürün Adı*"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <CategorySelect
                    v-model="newProduct.category"
                    label="Kategori*"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newProduct.description"
                    label="Açıklama"
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
            <small>* ile işaretli alanlar zorunludur</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> İptal </v-btn>
            <v-btn color="success" text @click="submitNewProduct">
              Kaydet
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </MainLayout>
</template>

<script>
import { useStore } from "vuex";
import { computed } from 'vue';
import CategorySelect from "@/components/CategorySelect.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import mainService from "@/services/mainService";

import Chart from "chart.js/auto";
import Swal from "sweetalert2";

export default {
  name: "PhoneDashboard",
  components: {
    MainLayout,
    CategorySelect,
  },
  created() {
    this.fetchRates();
  },

  setup() {
    const store = useStore();

    const categoryList = computed(() => store.state.categoryList);

    // fetchSellerList'i çağır
    const fetchCatgeoryList = () => {
      store.dispatch("fetchCatgeoryList");
    };

    // Bileşen oluşturulduğunda satıcı listesini yükle
    fetchCatgeoryList();

    return {
      categoryList,
    };
  },

  data: () => ({
    breadcrumbs: [
      {
        title: "Anasayfa",
        disabled: false,
        href: "pDashboard",
      },
      {
        title: "Genel İstatistik",
        disabled: false,
        href: "",
      },
    ],
    // İstatistikler
    totalPhones: 245,
    totalAccessories: 567,
    dailyRevenue: 25450,
    monthlyRevenue: 750680,
    currentYear: new Date().getFullYear(),
    ratesList: [],
    // Döviz kurları
    lastUpdate: "14:30",
    // Tablo
    search: "",
    headers: [
      { text: "Ürün Kodu", value: "code" },
      { text: "Ürün Adı", value: "name" },
      { text: "Kategori", value: "category" },
      { text: "Stok", value: "stock" },
      { text: "Son Güncelleme", value: "lastUpdate" },
      { text: "İşlemler", value: "actions", sortable: false },
    ],
    lowStockItems: [
      {
        code: "IP13-128",
        name: "iPhone 13 128GB",
        category: "Telefon",
        stock: 3,
        lastUpdate: "2024-03-15",
      },
      {
        code: "SM-S24U",
        name: "Samsung S24 Ultra",
        category: "Telefon",
        stock: 5,
        lastUpdate: "2024-03-14",
      },
    ],

    // Dialog
    dialog: false,
    newProduct: {
      name: "",
      category: "",
      description: "",
    },

    // Grafikler
    salesChart: null,
    revenueChart: null,
  }),

  computed: {
    displayRates() {
      if (!this.ratesList || this.ratesList.length === 0) {
        return {
          usd: "0.00",
          eur: "0.00",
          gbp: "0.00",
          usdChange: 0,
          eurChange: 0,
          gbpChange: 0,
        };
      }

      const usdRate = this.ratesList.find((rate) => rate.code === "USD");
      const eurRate = this.ratesList.find((rate) => rate.code === "EUR");
      const gbpRate = this.ratesList.find((rate) => rate.code === "GBP");

      return {
        usd: usdRate?.banknote_selling || "0.00",
        eur: eurRate?.banknote_selling || "0.00",
        gbp: gbpRate?.banknote_selling || "0.00",
        // Değişim oranlarını hesaplamak için alış-satış farkını kullanabiliriz
        usdChange: this.calculateChange(usdRate),
        eurChange: this.calculateChange(eurRate),
        gbpChange: this.calculateChange(gbpRate),
      };
    },
  },
  mounted() {
    this.initCharts();
    this.fetchRates();
  },

  beforeUnmount() {
    if (this.salesChart) {
      this.salesChart.destroy();
    }
    if (this.revenueChart) {
      this.revenueChart.destroy();
    }
  },

  methods: {
    calculateChange(rate) {
      if (!rate) return 0;
      // Alış ve satış fiyatı arasındaki farkı yüzde olarak hesapla
      const buying = parseFloat(rate.banknote_buying);
      const selling = parseFloat(rate.banknote_selling);
      return Number((((selling - buying) / buying) * 100).toFixed(2));
    },

    async fetchRates() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .fetchRates()
        .then((response) => {
          this.ratesList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    },

    getRateColor(change) {
      if (change > 0) return "success";
      if (change < 0) return "error";
      return "info";
    },

    getStockColor(stock) {
      if (stock <= 3) return "error";
      if (stock <= 5) return "warning";
      return "success";
    },

    showNewProductDialog() {
      this.dialog = true;
    },

    async submitNewProduct() {
      console.log("Yeni ürün:", this.newProduct);
      try {
        await mainService.add(this.newProduct, "newproductdemands"); // Yeni kullanıcıyı ekle
        this.dialog = false;

        Swal.fire("Talep Eklenmiştir.");
      } catch (error) {
        console.error("Kullanıcı eklenirken hata oluştu:", error);
      }
    },

    createRestockRequest(item) {
      console.log("Stok talebi:", item);
      // API çağrısı burada yapılacak
    },

    initCharts() {
      this.$nextTick(() => {
        // Satış performans grafiği
        const salesCtx = document.getElementById("salesChart");
        if (salesCtx) {
          this.salesChart = new Chart(salesCtx, {
            type: "bar",
            data: {
              labels: ["Ahmet", "Mehmet", "Ayşe", "Fatma", "Ali"],
              datasets: [
                {
                  label: "Günlük Satış (TL)",
                  data: [12500, 19000, 15000, 17500, 14000],
                  backgroundColor: "rgba(54, 162, 235, 0.5)",
                  borderColor: "rgba(54, 162, 235, 1)",
                  borderWidth: 1,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: "top",
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => this.formatCurrency(value),
                  },
                },
              },
            },
          });
        }

        // Aylık ciro grafiği
        const revenueCtx = document.getElementById("revenueChart");
        if (revenueCtx) {
          this.revenueChart = new Chart(revenueCtx, {
            type: "line",
            data: {
              labels: [
                "Ocak",
                "Şubat",
                "Mart",
                "Nisan",
                "Mayıs",
                "Haziran",
                "Temmuz",
                "Ağustos",
                "Eylül",
                "Ekim",
                "Kasım",
                "Aralık",
              ],
              datasets: [
                {
                  label: "Aylık Ciro (TL)",
                  data: [
                    650000, 590000, 800000, 810000, 560000, 550000, 750000,
                    690000, 900000, 850000, 750000, 950000,
                  ],
                  fill: false,
                  borderColor: "rgb(75, 192, 192)",
                  tension: 0.1,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: "top",
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => this.formatCurrency(value),
                  },
                },
              },
            },
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  transition: all 0.3s ease-in-out;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.currency-card {
  transition: all 0.3s ease;
}

.currency-card:hover {
  background-color: #f5f5f5;
}

.chart-container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
